import { Box, Typography, IconButton } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowRight } from "@mui/icons-material";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { connect } from "react-redux";
import makeStyles from "@mui/styles/makeStyles";
import { isTagEntry } from "./cellUtils";
import { selectModeData } from "../../../redux/selectors/editor";
import {ISheetModeData, updateModeData} from "../../../redux/slices/editor";
import { useEffect, useMemo } from "react";

const useStyles = makeStyles((theme) => ({
    groupCell: {
        display: "flex",
        justifyContent: "space-between",
        alignContent: "center",
        flexGrow: 1,
        "& p": { margin: "auto 0" }
    },
}));

interface Props extends GridRenderCellParams
{
    modeData: ISheetModeData
    updateModeData: (modeData: Partial<ISheetModeData>) => void
}

function GroupExpandCell({ value, formattedValue, modeData, updateModeData }: Props)
{
    const classes = useStyles();

    const tag = isTagEntry(value) ? value.tags[0] : null;
    const expanded = useMemo(() => modeData.expanded ?? {}, [modeData.expanded]);
    const expandId = tag?.value as string ?? "";
    const isExpanded = expanded[expandId] ?? false;
    useEffect(() =>
    {
        if (tag && expandId && expanded[expandId] === undefined)
        {
            updateModeData({ expanded: { ...expanded, [expandId]: isExpanded } });
        }
    }, [expanded, expandId, isExpanded, updateModeData, tag]);
    return tag ? <Box className={classes.groupCell} >
        <Typography variant={"body2"}>{formattedValue} {value?.meta?.count !== undefined && `(${value.meta.count})`}</Typography>
        <Box>
            <IconButton onClick={() =>
            {
                updateModeData({ expanded: { ...expanded, [expandId]: !isExpanded } });
            }}>
                {isExpanded ? <KeyboardArrowDown fontSize={"small"} /> : <KeyboardArrowRight fontSize={"small"} />}
            </IconButton>
        </Box>
    </Box > : null
}

const mapStateToProps = (store: never) => ({
    modeData: selectModeData(store) ?? {} as ISheetModeData
});
export default connect(mapStateToProps, {
    updateModeData
})(GroupExpandCell);